export const SMALL = 's';
export const MEDIUM = 'm';
export const LARGE = 'l';
export const SMALL_COLOR = 'sc';
